import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ClienteDetalharComponent } from './cliente-detalhar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: ClienteDetalharComponent }
    ])],
    exports: [RouterModule]
})
export class ClienteDetalharRoutingModule { }
